
export const MATCHA_SITE = location.hostname === 'localhost'? "http://localhost:8888/" : process.env.MATCHA_MAIN_SITE + '/'

export const MATCHA_MEDIA_SSL_URL = 'https://matcha-jp.com/'
export const MATCHA_COMPANY_SSL_URL = 'https://company.matcha-jp.com/'
export const MATCHA_USER_SSL_URL = 'https://user.matcha-jp.com/'




// WEBPACK FOOTER //
// ./src/constants/index.js